import React from 'react';
import { ShieldAlert } from 'lucide-react';

/**
 * PromptGuardWarning — compact inline notice shown under a prompt input when
 * `inspectPrompt(prompt)` returns warnings. Members tick the acknowledge box
 * to proceed; otherwise the caller refuses to submit.
 */
export default function PromptGuardWarning({ warnings, ack, onAckChange }) {
  if (!warnings || warnings.length === 0) return null;
  return (
    <div data-testid="prompt-guard" className="rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-xs text-amber-200 space-y-2">
      <div className="flex items-center gap-1.5 font-bold">
        <ShieldAlert className="w-3.5 h-3.5" />
        <span>Smart Prompt Guard</span>
      </div>
      <div>Your prompt may be rejected by the safety filter. Review and adjust before spending a credit:</div>
      <ul className="list-disc pl-4 space-y-1">
        {warnings.map(w => (
          <li key={w.code}>
            <span className="font-semibold">{w.label}.</span> <span className="text-amber-100/80">{w.hint}</span>
          </li>
        ))}
      </ul>
      <label className="flex items-center gap-2 pt-1 text-amber-100 cursor-pointer">
        <input
          data-testid="prompt-guard-ack"
          type="checkbox"
          checked={ack}
          onChange={e => onAckChange(e.target.checked)}
          className="accent-amber-400"
        />
        <span>Submit anyway — I understand this may fail.</span>
      </label>
    </div>
  );
}
